import { IS_DANARAPAY } from 'src/constants';
import { SelectLang } from '../SelectLang';
import styles from './PublicHeader.module.css';

export const PublicHeader = () => {
  const logo = IS_DANARAPAY
    ? '/img/danarapay-main-logo.svg'
    : '/img/main-logo.png';
  const height = IS_DANARAPAY ? 32 : 24;
  return (
    <div className={styles.container}>
      <img src={logo} height={height} alt="Main Logo" />

      <SelectLang />
    </div>
  );
};
